import React, { Component } from 'react'
import { injectState } from 'freactal'
import styled from 'styled-components'
import { IconButton } from 'react-mdl'
import MappingDialog from '../../components/MappingDialog'
import isEqual from 'lodash.isequal'

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 0.25em;
  &:nth-child(2n + 1) {
    background-color: lightgrey;
  }
`
const Input = styled.input`flex-grow: 1;`

class Task extends Component {
  state = {
    editingMapping: false,
    showAllMapping: false,
    mapping: this.props.task.mapping,
  }
  componentWillReceiveProps({ task: { mapping } }) {
    if (!isEqual(this.state.mapping, mapping)) {
      this.setState({ mapping })
    }
  }
  toggleEditMapping = () =>
    this.setState(({ editingMapping }) => ({
      editingMapping: !editingMapping,
      // when toggling dialog change mapping back to props
      mapping: this.props.task.mapping,
    }))
  handleChangeMapping = mapping => this.setState({ mapping })
  saveMapping = () => {
    this.props.onChange(
      { ...this.props.task, mapping: this.state.mapping },
      this.props.index,
    )
    this.toggleEditMapping()
  }
  handleChangeText = ({ target }) =>
    this.props.onChange(
      { ...this.props.task, task: target.value },
      this.props.index,
    )
  handleDelete = () => this.props.onDelete(this.props.index)
  handleMoveUp = () => this.props.onMoveUp(this.props.index)
  handleMoveDown = () => this.props.onMoveDown(this.props.index)
  render() {
    const { task, mappingWhitelist } = this.props
    const { editingMapping, mapping } = this.state
    return (
      <Row>
        <Input onChange={this.handleChangeText} value={task.task} />
        <IconButton
          name="north"
          accent
          disabled={this.props.index===0}
          onClick={this.handleMoveUp}
        />
        <IconButton
          name="south"
          accent
          disabled={this.props.isLastItem}
          onClick={this.handleMoveDown}
        />
        <IconButton
          name="delete"
          accent
          disabled={!this.props.canDelete}
          onClick={this.handleDelete}
        />
        <IconButton name="map" accent onClick={this.toggleEditMapping} />
        {editingMapping &&
          <MappingDialog
            title="Mapping for Task"
            goBack={this.toggleEditMapping}
            mapping={mapping}
            mappingWhitelist={mappingWhitelist}
            onChangeMapping={this.handleChangeMapping}
            saveMapping={this.saveMapping}
          />}
      </Row>
    )
  }
}

export default injectState(Task)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/Task.js